import { NavLink } from 'react-router-dom';
import { Home, Activity, FileText, Pill, Sparkles, ClipboardList, User } from 'lucide-react';
import { motion } from 'framer-motion';

const navItems = [
  { to: '/', icon: Home, label: 'Home' },
  { to: '/test-motori', icon: Activity, label: 'Test' },
  { to: '/storico', icon: FileText, label: 'Storico' },
  { to: '/farmaci', icon: Pill, label: 'Farmaci' },
  { to: '/ai-insights', icon: Sparkles, label: 'AI' },
  { to: '/report', icon: ClipboardList, label: 'Report' },
  { to: '/profilo', icon: User, label: 'Profilo' },
];

export default function BottomNav() {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 glass-nav border-t border-slate-200/50 z-50"
      style={{ backdropFilter: 'blur(20px)' }}
    >
      <div className="max-w-screen-xl mx-auto px-2 py-2">
        <div className="flex justify-around items-center">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center min-w-[60px] h-16 rounded-2xl transition-all duration-300 ${
                  isActive
                    ? 'text-blue-600 bg-blue-50'
                    : 'text-slate-600 hover:text-blue-600 hover:bg-slate-100'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <motion.div
                    whileTap={{ scale: 0.95 }}
                    className="flex flex-col items-center gap-1"
                  >
                    <item.icon className="w-6 h-6" strokeWidth={isActive ? 2.5 : 2} />
                    <span className="text-xs font-medium">{item.label}</span>
                  </motion.div>
                </>
              )}
            </NavLink>
          ))}
        </div>
      </div>
    </nav>
  );
}
